package fr.frux.core.maps

import org.maplibre.compose.browser.installMapLibreCompose

/**
 * Installe l'intégration graphique navigateur de la carte, à appeler dans `onWasmReady` **avant**
 * `ComposeViewport`.
 *
 * MapLibre GL JS dessine dans le contexte GPU de Skiko : l'intégration doit être posée pendant que
 * ce contexte se crée, sinon la carte n'a pas de surface où rendre. Exposé par `core-maps` plutôt
 * qu'appelé directement par la webApp pour tenir le garde-fou n°1 de l'ADR 0001 : aucun type
 * MapLibre ne sort de ce module.
 *
 * @param workerUrl chemin same-origin du worker MapLibre GL JS, fourni par l'hôte. Le défaut de la
 *   bibliothèque est un CDN, que la CSP de l'ADR 0022 interdit.
 */
fun initializeWebMapRenderer(workerUrl: String) {
    installMapLibreCompose(workerUrl = workerUrl)
}
